import GenericButton from "components/Buttons/GenericButton";
import StepContainer from "../step-container";

import { Typography, useMediaQuery } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import getDataSetByNameAction from "redux/actions/datasetsAction";
import { createWorkCenterAction, getFilteredWorkCenterAction, getWorkCenterByIdAction, updateWorkCenterAction } from "redux/actions/workCentersAction";
import FilterSection from "views/admin/UserArea/UserColective/WorkCenters/FilterSection";
import ResultSection from "views/admin/UserArea/UserColective/WorkCenters/ResultSection";

import { useQuery, useQueryClient } from "@tanstack/react-query";
import { listWorkCenters } from "crud/workCenters.crud";
import { FormProvider, useForm } from "react-hook-form";
import WorkCenterDialog from "views/admin/UserArea/UserColective/WorkCenters/WorkCenterModal";

function WorkCentersInfoTab({ ...props }) {
  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down("sm"));

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedWorkCenter, setSelectedWorkCenter] = useState(null);
  const [isCreating, setIsCreating] = useState(false);
  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");

  const handleOpenDialog = (workCenter, isEditing, isCreating) => {
    setSelectedWorkCenter(workCenter);
    setIsCreating(isCreating);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedWorkCenter(null);
  };

  const queryClient = useQueryClient();

  useEffect(() => {
    return () => {
      queryClient.invalidateQueries({ queryKey: ["listWorkCenters"] });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const form = useForm({
    mode: "onChange",
    defaultValues: {
      name: "",
      provinceId: "",
      municipalityId: "",
      secondaryActivityId: "",
      pageIndex: 1,
      pageSize: 15,
    },
  });

  const { getValues, setValue, reset, watch } = form;
  const pageIndex = watch("pageIndex") ?? 1;
  const pageSize = watch("pageSize") ?? 15;

  const workCentersQuery = useQuery(
    ["listWorkCenters"],
    () =>
      listWorkCenters({
        ...getValues(),
        sortColumn,
        sortDirection,
      }),
    {
      enabled: true,
      staleTime: 0,
      refetchOnMount: "always",
    }
  );

  useEffect(() => {
    // Garantir carregamento inicial ao entrar no step (mesmo se existir cache "fresh")
    workCentersQuery.refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <StepContainer
      title="Dados de Centros"
      action={
        <GenericButton
          onClick={() => handleOpenDialog(null, false, true)}
          color="tertiary"
          size={isSmDown ? "medium" : "small"}
          fullWidth={isSmDown}
        >
          Criar Centro
        </GenericButton>
      }
    >
      <FormProvider {...form}>
        <>
          <FilterSection
            sortColumn={sortColumn}
            sortDirection={sortDirection}
            isLoading={workCentersQuery.isFetching}
            onSearch={async () => {
              if (pageIndex !== 1) setValue("pageIndex", 1);
              await workCentersQuery.refetch();
            }}
            onClear={async () => {
              reset({
                name: "",
                provinceId: "",
                municipalityId: "",
                secondaryActivityId: "",
                pageIndex: 1,
                pageSize: 15,
              });
              await workCentersQuery.refetch();
            }}
          />

          <Typography
            style={{
              fontWeight: 600,
            }}
            component="p"
            variant="body2"
          >
            Na tabela em baixo estão listados todos os centros de trabalho que integram os registos da área de
            utilizador e serão integrados no relatório RENT. <br />
            Poderá editar as informações entrando no detalhe de cada centro de trabalho. Após gravar ou adicionar o
            centro de trabalho, a lista de centros de trabalho no menu utilizadores será actualizada.
          </Typography>

          <ResultSection
            handleOpenDialog={handleOpenDialog}
            sortColumn={sortColumn}
            setSortColumn={setSortColumn}
            sortDirection={sortDirection}
            setSortDirection={setSortDirection}
            onPaginationChange={async (nextPageIndex) => {
              setValue("pageIndex", nextPageIndex);
              await workCentersQuery.refetch();
            }}
            onResetToFirstPage={() => {
              setValue("pageIndex", 1);
            }}
          />
        </>
      </FormProvider>

      {openDialog && (
        <WorkCenterDialog
          openDialog={openDialog}
          handleCloseDialog={handleCloseDialog}
          getDataSetByName={props.getDataSetByName}
          props={props}
          isCreating={isCreating}
          selectedWorkCenter={selectedWorkCenter}
          redirect={false}
          creatingFromRENT={true}
        />
      )}
    </StepContainer>
  );
}

const mapStateToProps = (state) => ({ ...state });

const mapDispatchToProps = (dispatch) => ({
  getDataSetByName: (name, addEmptyField) => dispatch(getDataSetByNameAction(name, addEmptyField)),
  createWorkCenter: (data) => dispatch(createWorkCenterAction(data)),
  updateWorkCenter: (data) => dispatch(updateWorkCenterAction(data)),
  getWorkCenterById: (id) => dispatch(getWorkCenterByIdAction(id)),
  getFilteredWorkCenters: (data) => dispatch(getFilteredWorkCenterAction(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WorkCentersInfoTab);
